export default __webpack_public_path__ + "static/media/Latest Grant Letter 1.55601ad6.pdf";